/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './header.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '@angular/router';
import * as import4 from '../../../../app/ui/header/header.component';
import * as import5 from '../../../../app/notification/notification.service';
import * as import6 from '../../../../app/booking-management/booking-header/booking-header.service';
import * as import7 from '../../../../app/api/messaging.service';
import * as import8 from '../../../../app/shared/user-name.service';
import * as import9 from '../../../../app/shared/router/linkhelper';
import * as import10 from '../../../../app/shared/sub-organisation-filter/sub-organisation-filter.service';
const styles_HeaderComponent:any[] = [import0.styles];
export const RenderType_HeaderComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_HeaderComponent,
  data: {}
}
);
function View_HeaderComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'a',[[
        'id',
        'lnkBooking'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.setActiveLink(co.linkName.booking)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    import1.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-bookings'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' BOOKINGS']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = ck(v,2,0,co.isActiveLink(co.linkName.booking));
    ck(v,1,0,currVal_2);
    const currVal_3:any = ck(v,4,0,'/booking-management');
    ck(v,3,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,3).target;
    const currVal_1:any = import1.ɵnov(v,3).href;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'messages-ticker'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgStyle,[
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
    import1.ɵpod(['left']),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,co.isAdmin());
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.unreadMessageThreads;
    ck(v,3,0,currVal_1);
  });
}
function View_HeaderComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),12,'a',[
      [
        'id',
        'lnkMessages'
      ]
      ,
      [
        'name',
        'lnkMessages'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.setActiveLink(co.linkName.messages)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    import1.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(3),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_4)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-messages'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' MESSAGES'])),
    (l()(),import1.ɵted((null as any),['\n		']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = ck(v,2,0,co.isActiveLink(co.linkName.messages));
    ck(v,1,0,currVal_2);
    const currVal_3:any = ck(v,4,0,'/users/',co.getActiveUserId(),'inbox');
    ck(v,3,0,currVal_3);
    const currVal_4:any = co.isCurrentUserAdminOrBookingOfficer();
    ck(v,7,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,3).target;
    const currVal_1:any = import1.ɵnov(v,3).href;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'a',[[
        'id',
        'lnkReport'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.setActiveLink(co.linkName.reports)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    import1.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-reports'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' REPORTS ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = ck(v,2,0,co.isActiveLink(co.linkName.reports));
    ck(v,1,0,currVal_2);
    const currVal_3:any = ck(v,4,0,'/reports');
    ck(v,3,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,3).target;
    const currVal_1:any = import1.ɵnov(v,3).href;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'nav',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_2)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_3)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_5)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n	']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.canShowLink('booking-management');
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.canShowLink('messages') && co.isCurrentUserNotIndividualClientOrOrg());
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.canShowLink('reports');
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_HeaderComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'button'
      ]
      ,
      [
        'id',
        'lnkNewBooking'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        co.setActiveLink(co.linkName.booking);
        const pd_1:any = ((<any>co.refreshBooking()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['active']),
    import1.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(2),
    (l()(),import1.ɵted((null as any),['+ New Booking']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = 'button';
    const currVal_3:any = ck(v,2,0,co.isActiveLink(co.linkName.booking));
    ck(v,1,0,currVal_2,currVal_3);
    const currVal_4:any = ck(v,4,0,'/booking-management','create-booking');
    ck(v,3,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,3).target;
    const currVal_1:any = import1.ɵnov(v,3).href;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_9(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.subOrganisationFilter.select(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'a',([] as any[]),[[
        1,
        'class',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.id;
    ck(v,1,0,currVal_0);
  });
}
function View_HeaderComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),12,'ul',[
      [
        'class',
        'dsq-service-dropdown dropdown menu click-handler'
      ]
      ,
      [
        'data-click-open',
        'true'
      ]
      ,
      [
        'data-disable-hover',
        'true'
      ]
      ,
      [
        'data-dropdown-menu',
        ''
      ]
      ,
      [
        'onclick',
        'this.classList.toggle(\'opened\');'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n				'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'a',([] as any[]),[[
        1,
        'class',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n				'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'ul',[[
        'class',
        'menu right-side green'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n					'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_9)),
    import1.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n				'])),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵted((null as any),['\n		']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.subOrganisationFilter.unselectedList;
    ck(v,9,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.subOrganisationFilter.selected == null)? (null as any): co.subOrganisationFilter.selected.id);
    ck(v,4,0,currVal_0);
  });
}
function View_HeaderComponent_10(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),6,'a',[[
        'id',
        'lnkSettings'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.setActiveLink(co.linkName.usermanagement)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    import1.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-settings'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' Users']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = ck(v,2,0,co.isActiveLink(co.linkName.usermanagement));
    ck(v,1,0,currVal_2);
    const currVal_3:any = ck(v,4,0,'/user-management');
    ck(v,3,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,3).target;
    const currVal_1:any = import1.ɵnov(v,3).href;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),38,'section',[[
        'class',
        'group-dropdown'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_8)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),32,'ul',[
      [
        'class',
        'dropdown menu click-handler'
      ]
      ,
      [
        'data-click-open',
        'true'
      ]
      ,
      [
        'data-disable-hover',
        'true'
      ]
      ,
      [
        'data-dropdown-menu',
        ''
      ]
      ,
      [
        'onclick',
        'this.classList.toggle(\'opened\');'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),29,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n				'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'ImgSize'
      ]
      ,
      [
        'id',
        'lnkProfile'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setActiveLink(co.linkName.profile)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),['\n					'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',([] as any[]),[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n				'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'ul',[[
        'class',
        'menu right-side green'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n					'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),6,'a',[[
        'id',
        'lnkProfile1'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,22).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.setActiveLink(co.linkName.profile)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    import1.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(2),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-user'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' Profile'])),
    (l()(),import1.ɵted((null as any),['\n					'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_10)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n					'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[[
        'id',
        'lnkLogout'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.userLogout()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-logout'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' Log Out'])),
    (l()(),import1.ɵted((null as any),['\n				'])),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵted((null as any),['\n	']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.subOrganisationFilter.isVisibleToUser(co.currentUser);
    ck(v,3,0,currVal_0);
    const currVal_1:any = 'ImgSize';
    const currVal_2:any = ck(v,11,0,co.isActiveLink(co.linkName.profile));
    ck(v,10,0,currVal_1,currVal_2);
    const currVal_7:any = ck(v,21,0,co.isActiveLink(co.linkName.profile));
    ck(v,20,0,currVal_7);
    const currVal_8:any = ck(v,23,0,'/user-management','profile');
    ck(v,22,0,currVal_8);
    const currVal_9:any = co.canShowLink('user-management');
    ck(v,29,0,currVal_9);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = import1.ɵinlineInterpolate(1,'',co.getPicturePath(),'');
    ck(v,13,0,currVal_3);
    const currVal_4:any = co.fullName;
    ck(v,14,0,currVal_4);
    const currVal_5:any = import1.ɵnov(v,22).target;
    const currVal_6:any = import1.ɵnov(v,22).href;
    ck(v,19,0,currVal_5,currVal_6);
  });
}
export function View_HeaderComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),12,'header',[[
        'id',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n	'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'alt',
        'Auslan Connections'
      ]
      ,
      [
        'height',
        '46'
      ]
      ,
      [
        'name',
        'auslanLogo'
      ]
      ,
      [
        'src',
        'assets/img/auslan-logo.png'
      ]
      ,
      [
        'width',
        '72'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n	'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_1)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n	'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_6)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n	'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_7)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.HeaderComponent = v.component;
    const currVal_0:any = co.userIsActive;
    ck(v,5,0,currVal_0);
    const currVal_1:any = (co.userIsActive && co.canShowLink('create-booking'));
    ck(v,8,0,currVal_1);
    const currVal_2:any = co.userIsActive;
    ck(v,11,0,currVal_2);
  },(null as any));
}
function View_HeaderComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-header',([] as any[]),(null as any),(null as any),(null as any),View_HeaderComponent_0,RenderType_HeaderComponent)),
    import1.ɵdid(245760,(null as any),0,import4.HeaderComponent,[
      import5.NotificationServiceBus,
      import6.BookingHeaderService,
      import1.NgZone,
      import7.MessagingService,
      import2.Location,
      import3.Router,
      import8.UserNameService,
      import9.LinkAuth,
      import10.SubOrganisationFilterService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const HeaderComponentNgFactory:import1.ComponentFactory<import4.HeaderComponent> = import1.ɵccf('app-header',import4.HeaderComponent,View_HeaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/ui/header/header.component.ngfactory.ts